<template>
  <div>
    <el-form
      label-position="top"
      ref="ruleForm"
      hide-required-asterisk="true"
      label-width="80px"
      :model="formLabelAlign"
    >
      <div v-for="(item, index) in lan" :key="index">
        <el-form-item
          label=""
          :prop="`name${item.value}`"
          :rules="[{ required: true, message: setMessage(item.value), trigger: 'blur' }]"
        >
          <div slot="label">
            <div class="label-text">
              {{ item.value == "En" ? "英文名稱" : "中文名稱" }}
              <span class="star-mark">*</span>
            </div>
          </div>
          <el-input v-model="formLabelAlign[`name${item.value}`]"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="" prop="abbreviation" :rules="[{ required: true, message: '請輸入分校名稱縮寫', trigger: 'blur' }]">
        <div slot="label">
          <div class="label-text">
            分校名稱縮寫<span class="star-mark">*</span>
          </div>
        </div>
        <el-input v-model="formLabelAlign.abbreviation"></el-input>
      </el-form-item>
    </el-form>
    <div>請注意：標有 (*) 的為必填項。</div>
  </div>
</template>

<script>
export default {
  props: {
    formLabelAlign: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    return {
      lan: [
        {
          label: "En",
          value: "En",
        },
        {
          label: "Zh",
          value: "Zh",
        },
      ],
    };
  },
  methods:{
    setMessage(value){
      return value == 'En' ? '請輸入英文名稱' : '請輸入中文名稱'
    }
  }
};
</script>

<style lang="scss" scoped>
</style>